import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid lg:grid-cols-2 gap-2 lg:gap-5" }

import { pb } from "@/pocketbase";
import Title from "@/components/Title.vue";
import LinkBox from "@/components/LinkBox.vue";
import Heading from "@/components/Heading.vue";
import Divider from "@/components/Divider.vue";
import Content from "@/components/Content.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'EventsView',
  setup(__props) {

const user: { name: string } = pb.authStore.model;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Title, null, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("Events")
      ])),
      _: 1,
      __: [0]
    }),
    _createVNode(Divider),
    _createVNode(Content, null, {
      default: _withCtx(() => [
        _createVNode(Heading, null, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Archive")
          ])),
          _: 1,
          __: [1]
        }),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(LinkBox, {
            route: "retreat-2025",
            title: "R&D Retreat 2025",
            description: "Our first in-person multi-day retreat, hosted in Berlin."
          }),
          _createVNode(LinkBox, {
            route: "technology-day-2024",
            title: "Technology Day 2025",
            description: "Our first one-day online conference held by and for TSG R&D teams."
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})